import * as type from '../actions/types';

const initialState = {
    applications: [],
    id: 0,
    flags: {}
};

export default function(state = initialState, action) {
    switch (action.type) {
      case type.APPLICATION_ID:
        return {
            ...state,
            id: action.payload
        };
        case type.INITIAL_APP_ID:
            return {
                ...state,
                id: initialState.id
            };
        case type.SUCCESS_APPLICATION_LIST:
        return {
            ...state,
            applications: action.payload
        };
        case type.SET_APPLICATION_FLAGS:
        return {
            ...state,
            flags: action.payload
        };
        default:
        return state;
    }
}